<div class="list-container">
  <form [formGroup]="searchForm">
    <bw-input-legacy
      [label]="'PROFESSION' | translate"
      type="text"
      [placeholder]="'SEARCH' | translate"
      formControlName="inputText"
      (hasFocus)="onSearchInputFocusState($event)"
    ></bw-input-legacy>
  </form>

  <div
    *ngIf="isSearchInputFocused && !isEmptySearchText"
    class="list-display-container"
    (mousedown)="$event.preventDefault()"
  >
    <ng-container *ngIf="displayedListItems.length > 0; else noRecordsFound">
      <bw-cell-legacy
        *ngFor="let displayItem of displayedListItems"
        [contentLeft]="true"
        [iconNameRight]="'chevron_right'"
        [separatorType]="'full'"
        (clicked)="onProfessionClicked(displayItem)"
      >
        <ng-container content-left>
          <typography-legacy text-medium-regular>
            <p>{{ displayItem.displayName }}</p>
          </typography-legacy>
        </ng-container></bw-cell-legacy
      >
    </ng-container>
    <ng-template #noRecordsFound>
      <p class="body bs-light-gray no-match-copy">
        {{ 'NO_MATCHES' | translate }}
      </p>
    </ng-template>
  </div>
</div>
